/** Webpack-bundled avatars as JPEG — survives Amplify SPA rewrite (webp under /images/ was returning index.html). */
import drAtchyut from "../images/testimonials/dr-atchyut.jpg";
import female1 from "../images/testimonials/female1.jpg";
import female2 from "../images/testimonials/female2.jpg";
import female3 from "../images/testimonials/female3.jpg";
import male2 from "../images/testimonials/male2.jpg";
import male4 from "../images/testimonials/male4.jpg";

export const TESTIMONIAL_AVATARS = {
  drAtchyut,
  female1,
  female2,
  female3,
  male2,
  male4,
};
